import React, { ComponentPropsWithoutRef } from 'react';
import { FormattedMessage } from 'react-intl';
import { ScrollableSource } from '@eas/common-web';
import { CollectionField } from '@components/collection-field/collection-field';
import { DictionaryAutocomplete } from '@models';
import { EvidenceApiUrl } from '@enums';
import { useColumns } from './mismatch-columns';

interface MismatchFieldProps
  extends Partial<
    ComponentPropsWithoutRef<typeof CollectionField<DictionaryAutocomplete>>
  > {
  source: ScrollableSource<DictionaryAutocomplete>;
}

export function MismatchField({ source, ...overrides }: MismatchFieldProps) {
  return (
    <CollectionField<DictionaryAutocomplete>
      title={
        <FormattedMessage
          id="ZSD__FIELD_LABEL__MISMATCH"
          defaultMessage="Nesúlad s realitou"
        />
      }
      source={source}
      useColumns={useColumns}
      disabled={false}
      createAction={{
        hide: true,
        getUrl: () => EvidenceApiUrl.MISMATCH,
      }}
      readAction={{
        getUrl: (collectionId) => `${EvidenceApiUrl.MISMATCH}/${collectionId}`,
      }}
      updateAction={{
        hide: true,
        getUrl: (_, collectionId) =>
          `${EvidenceApiUrl.MISMATCH}/${collectionId}`,
      }}
      deleteAction={{
        hide: true,
        getUrl: (_, collectionId) =>
          `${EvidenceApiUrl.MISMATCH}/${collectionId}`,
      }}
      assignAction={{
        hide: true,
        getUrl: (_, collectionId) =>
          `${EvidenceApiUrl.MISMATCH}/${collectionId}`,
      }}
      unassignAction={{
        hide: true,
        getUrl: (_, collectionId) =>
          `${EvidenceApiUrl.MISMATCH}/${collectionId}`,
      }}
      {...overrides}
    />
  );
}
